import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { immerable } from "immer";
import { AclAssetAccessLevel } from "./acl-asset-access-level";
import { AclTypes } from "./acl-types";
import { AclWorkflowAccessLevel } from "./acl-workflow-access-level";
import { CurrencyTypes } from "./currency-types";
import { CustomLayerFilter } from "./custom-layer-filter";
import { GroupPlanningInfos } from "./group-planning-infos";
import { IDbBaseMetadataValueInfos } from "./i-db-base-metadata-value-infos";
import { ObjectClass } from "./object-class";

export class DbUserGroupInfos extends DbMongoSerializationBaseInfos {
  [immerable] = true;
  enabled: boolean = false;
  platformId: number = 0;
  aclWorkflowAccessLevel: AclWorkflowAccessLevel | null = null;
  aclAssetAccessLevel: AclAssetAccessLevel | null = null;
  name: string | null = null;
  description: string | null = null;
  entityId: number | null = 0;
  maxShareViewDays: number | null = 0;
  maxShareViews: number | null = 0;
  maxShareViewIPs: number | null = 0;
  maxShareViewClipsNumber: number | null = 0;
  maxShareViewClipsDuration: string | null = null;
  defaultShareViewDays: number | null = 0;
  defaultShareViews: number | null = 0;
  defaultShareViewIPs: number | null = 0;
  defaultShareViewClipsNumber: number | null = 0;
  defaultShareViewClipsDuration: string | null = null;
  defaultShareName: string | null = null;
  filterTitleIds: number[] | null = null;
  labProviderIds: number[] | null = [];
  allowedObjectClasses: ObjectClass[] | null = null;
  acls: AclTypes[] | null = [];
  filterTitleBusinessUnits: string[] | null = null;
  filterContents: IDbBaseMetadataValueInfos[] | null = null;
  customFilters: CustomLayerFilter[] | null = null;
  currency: CurrencyTypes | null = null;
  customerIds: number[] | null = null;
  roleId: number | null = null;
  planningInfos: GroupPlanningInfos | null = null;

  constructor(init?: Partial<DbUserGroupInfos>) {
    super();
    Object.assign(this, init);
  }
}
